<template>
    <div class="lp-wave-content">
      <div class="lp-wave-login ly-row ly-center-center">
        <div class="ly-col ly-center-center forgot-password-container" v-load-fade-in="{ delay: 1000, timeBetween: 500 }">
          <transition name="fade">
            <div v-show="true" class="card lp-load-fadein">
              <ResetPasswordSuccessView v-if="showSuccessView" @loginSubmitted="onAutoLoginTriggered"></ResetPasswordSuccessView>
              <NewResetPasswordForm v-else @formSubmitted="onResetPasswordFormSubmitted" @errorCatched="displayError" :isSubmitting="submitting" :hasExpiredCode="hasExpiredCode" />
              <div class="msg msg-error w-100 text-center" v-if="errorMessage">
                {{ errorMessage }}
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
</template>

<script setup lang="ts">
import { ref, inject, Ref } from 'vue'
import NewResetPasswordForm from './components/NewResetPasswordForm.vue'
import ResetPasswordSuccessView from './components/ResetPasswordSuccessView.vue'

const errorMessage: Ref<string> = ref('')
const hasExpiredCode: Ref<boolean> = ref(false)
const submitting: Ref<boolean> = ref(false)
const username: Ref<string> = ref('')
const password: Ref<string> = ref('')
const showSuccessView: Ref<boolean> = ref(false)
const usernamePasswordLogin = inject('usernamePasswordLogin') as (username: string, password: string, selectedService: ServiceNames) => Promise<void>
const resetPassword = inject('resetPassword') as (username: string, password: string, code: string) => Promise<void>

const onResetPasswordFormSubmitted = async (params: { username: string, password: string, code: string }) => {
  if (submitting.value) return
  submitting.value = true

  resetPassword(params.username, params.password, params.code).then(() => {
    username.value = params.username
    password.value = params.password
    showSuccessView.value = true
    submitting.value = false
  }).catch((error: any) => {
    hasExpiredCode.value = error?.code === 'ExpiredCodeException'
    submitting.value = false

    displayError(error)
  })
}

const onAutoLoginTriggered = async (params: any) => {
  if (submitting.value) return
  submitting.value = true
  try {
    const appId = window.localStorage.getItem('appId') || 'LMS'
    await usernamePasswordLogin(username.value, password.value, appId)
  } catch (error: any) {
    displayError(error)
  }
  submitting.value = false
}

const displayError = (error: any) => {
  error.message
    ? errorMessage.value = error.message
    : errorMessage.value = 'Unexpected Error'
}
</script>

<style scoped>
  .forgot-password-container {
  background: transparent !important;
  padding-bottom: 120px !important;
}

.forgot-password-container .card {
  width: 550px;
  box-shadow: none !important;
  background: transparent !important;
}
</style>
